import React, { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { X, KeyRound, Loader2 } from "lucide-react";

export default function ChangePasswordDialog({ onClose }) {
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const inp = "mt-1 w-full px-3 py-2 border border-slate-300 rounded-lg font-mono";

  const submit = async (e) => {
    e.preventDefault();
    if (f.new_password.length < 8) { toast.error("La nuova password deve avere almeno 8 caratteri"); return; }
    if (f.new_password !== f.confirm) { toast.error("Le password non coincidono"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Password aggiornata");
      onClose();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Errore aggiornamento password");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-lg border border-slate-200 shadow-xl w-full max-w-sm" onClick={(e) => e.stopPropagation()} data-testid="change-password-dialog">
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200">
          <h3 className="font-display font-semibold text-lg flex items-center gap-2"><KeyRound size={18} /> Cambia password</h3>
          <button onClick={onClose}><X size={20} /></button>
        </div>
        <form onSubmit={submit} className="p-6 space-y-3">
          <div><label className="text-sm font-medium text-slate-700">Password attuale</label>
            <input type="password" required value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} className={inp} data-testid="cp-current" /></div>
          <div><label className="text-sm font-medium text-slate-700">Nuova password (min. 8 caratteri)</label>
            <input type="password" required value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className={inp} data-testid="cp-new" /></div>
          <div><label className="text-sm font-medium text-slate-700">Conferma nuova password</label>
            <input type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={inp} data-testid="cp-confirm" /></div>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-slate-600">Annulla</button>
            <button type="submit" disabled={busy} data-testid="cp-submit" className="px-4 py-2 bg-slate-900 text-white rounded-lg disabled:opacity-60 inline-flex items-center gap-2">
              {busy && <Loader2 size={14} className="animate-spin" />} Aggiorna
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
